module.exports = __webpack_public_path__ + "img/T2.700314ea.jpg";